import React from 'react';
import { t } from 'ttag';
import Slide, { ISlide } from '../../../../core/Slide';
import { CharacterDialogue } from '../../../../general/Character';
import { DialogueData } from '../../../../general/Dialogue';
import useFooterButtonRenderer from '../../../../misc/FooterButtonRenderer';
import AgentGreen from '../../characters/AgentGreen';

const LabIntro2: React.FC<ISlide> = ({ defaultHeader, nextSlide }) => {
    const [footer, buttonRenderer] = useFooterButtonRenderer();

    const dialogue: DialogueData[] = [
        {
            character: AgentGreen,
            text: t`A Caesar Cipher offsets every letter in the alphabet by a given number, for example an offset of two would turn A into C, B into D, C into E... and so on. An offset of zero would just turn A into A!`,
            buttonText: t`Next`,
        },
        {
            character: AgentGreen,
            text: t`Let me show you an example of this cipher in action.`,
            buttonText: t`Next`,
            buttonAction: nextSlide,
        },
    ];

    return (
        <Slide header={defaultHeader} footer={footer}>
            <CharacterDialogue dialogue={dialogue} buttonHandler={buttonRenderer} />
        </Slide>
    );
};

export default LabIntro2;
